export const types = {
  SEND_VIRTUAL_CARD_FILE: 'SEND_VIRTUAL_CARD_FILE',
  SET_VIRTUAL_CARD_TOKEN: 'SET_VIRTUAL_CARD_TOKEN',
  SET_FILE_SUMMARY: 'SET_FILE_SUMMARY',
  RESET: 'RESET',
  SET_TOTAL: 'SET_TOTAL',
  HYDRATE: 'HYDRATE',
};
